<ps-ui-header
  (closeSurvey)="goToDashboard($event)"
  (openServiceAccountModal)="selectBuyer($event)"
></ps-ui-header>
<ps-ui-buyer-redirect-guide></ps-ui-buyer-redirect-guide>
